import { Box } from '@chakra-ui/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { SaveButton } from '../../../components/StyledButton';
import useToastHook from '../../../hooks/ToastHook';
import { AssignWorkInfoDaySearchResult } from '../../../models/gen/assignWorkInfoDaySearchResult';
import { useDailyWork } from './DailyWork';
import Matters from './Matters';

/**
 *
 */
type WorkReportBodyProps = {
  canSave: boolean;
  checkCanSave: Runnable;
  isOvertime: boolean;
  matterSize: number;
  mode: 'view' | 'edit';
  onOpen: Consumer<AssignWorkInfoDaySearchResult | undefined>;
  recalculateDailyWork: Runnable;
  totalWorkTime: number;
  validateForSave: Supplier<Array<string>>;
  workTimeFrom: string | null;
  workTimeTo: string | null;
  ATTENDANCE_TYPE_PRESENT?: number;
};

/**
 *
 * @returns
 */
const WorkReportBody: React.FunctionComponent<WorkReportBodyProps> = (
  props
) => {
  const form = useFormContext<AssignWorkInfoDaySearchResult>();
  const { DailyWork, isAbsence, toggle } = useDailyWork();
  const { toast } = useToastHook();

  return (
    <>
      <DailyWork
        isOvertime={props.isOvertime}
        matterSize={props.matterSize}
        mode={props.mode}
        totalWorkTime={props.totalWorkTime}
        workTimeFrom={props.workTimeFrom}
        workTimeTo={props.workTimeTo}
        ATTENDANCE_TYPE_PRESENT={props.ATTENDANCE_TYPE_PRESENT}
      />
      <Matters
        isAbsence={isAbsence}
        matterIndex={0}
        matterSize={props.matterSize}
        mode={props.mode}
        toggle={toggle}
        onChangedRelatedToSavable={props.checkCanSave}
        onChangedRelatedToDailyWork={props.recalculateDailyWork}
      />
      <Box width="full">
        {props.mode === 'edit' ? (
          <SaveButton
            isDisabled={!props.canSave}
            type="button"
            onClick={() => {
              const warns = props.validateForSave();
              if (warns.length > 0) {
                warns.forEach((warn, index) => {
                  setTimeout(() => {
                    toast(warn, 'warning');
                  }, index * 100);
                });
              } else {
                form.handleSubmit(props.onOpen)();
              }
            }}
          />
        ) : null}
      </Box>
    </>
  );
};

export default WorkReportBody;
